export default __webpack_public_path__ + "static/rocket-color-ed58875e27bd6935fe846996b2ba7c5f.png";